<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('motivo-atendimento') }}
                            <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('vendas') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('crm') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'ven-motivo-atendimento' })">{{
                                        $t('motivo-atendimento')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? descricao : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToList()"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>

                <ul class="nav nav-tabs nav-tabs-children" v-if="isUpdate">
                    <li
                        v-for="(aba, i) in abas"
                        v-if="aba !== 'produtosPesquisaMercado' || motivoHabilitaObrigaPesquisaMercado > 0"
                        :key="i"
                        v-show="permissao.read"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <!-- CONJUNTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        v-if="aba !== 'produtosPesquisaMercado' || motivoHabilitaObrigaPesquisaMercado > 0"
                        v-show="permissao.read"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>

                <Geral
                    ref="tabGeral"
                    v-if="abasAbertas['geral'] && !newToEdit && permissao.read"
                    v-show="abas[abaSelecionada] == 'geral'"
                    :isUpdate="isUpdate"
                    @habilitaObrigaPesquisaMercado="updateHabilitaObrigaPesquisaMercado"
                    @isChanged="isChanged = $event"
                    @redirect="redirectToPage"
                    @descricao="updateDescricao"
                />
                <Formulario
                    ref="tabFormulario"
                    v-if="
                        abasAbertas['formulario'] && permissao.read && isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'formulario'"
                    :isUpdate="isUpdate"
                />

                <ProdutosPesquisaMercado
                    ref="tabProdutosPesquisaMercado"
                    v-if="
                        abasAbertas['produtosPesquisaMercado'] && permissao.read && isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'produtosPesquisaMercado'"
                    :isUpdate="isUpdate"
                />

            </div>
        </div>
    </div>
</template>

<script>
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

// Abas
import Geral from '@/components/vendas/motivo-atendimento/abas/Geral.vue';
import Formulario from "@/components/vendas/motivo-atendimento/abas/Formulario.vue";
import ProdutosPesquisaMercado from "@/components/vendas/motivo-atendimento/abas/ProdutosPesquisaMercado.vue";

export default {
    beforeRouteLeave(to, from, next) {
        if (from.name == 'ven-motivo-atendimento-new' && to.name == 'ven-motivo-atendimento-edit') {
            this.isUpdate = true;
            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        HideInfo,
        Geral,
        Formulario,
        ProdutosPesquisaMercado
    },
    data() {
        return {
            id: 0,
            abaSelecionada: 0,
            abas: ['geral', 'formulario', 'produtosPesquisaMercado'],
            abasAbertas: {},
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            permissao: false,
            descricao: '',
            motivoHabilitaObrigaPesquisaMercado: 0
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-motivo-atendimento');

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'motivo-atendimento' },
            });
        } else {
            this.abasAbertas['geral'] = true;
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        updateHabilitaObrigaPesquisaMercado(value) {
            this.motivoHabilitaObrigaPesquisaMercado = value;
        },
        updateDescricao(descricao) {
            this.descricao = descricao;
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({ name: 'ven-motivo-atendimento' });
            }, time * 1000 + 50);
        },
        redirectToPage(id) {
            this.isChanged = false;
            this.$router.push({
                name: 'ven-motivo-atendimento-edit',
                params: { id: id },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        .nav-tabs-children {
            margin-bottom: 20px;
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: '';
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
